import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Button } from "react-bootstrap";

const RippleButton = ({
  children,
  onClick,
  type,
  customStyles,
  testid,
  disabled,
  href,
}) => {
  const [coords, setCoords] = useState({ x: -1, y: -1 });
  const [isRippling, setIsRippling] = useState(false);

  useEffect(() => {
    if (coords.x !== -1 && coords.y !== -1) {
      setIsRippling(true);
      setTimeout(() => setIsRippling(false), 300);
    } else setIsRippling(false);
  }, [coords]);

  React.useEffect(() => {
    if (!isRippling) setCoords({ x: -1, y: -1 });
  }, [isRippling]);

  return (
    <Button
      className={`onboarding-button ripple-button ${customStyles}`}
      data-testid={testid}
      onClick={(e) => {
        const rect = e.target.getBoundingClientRect();
        setCoords({ x: e.clientX - rect.left, y: e.clientY - rect.top });
        onClick && onClick(e);
      }}
      {...(type && {
        type: "submit",
      })}
      disabled={disabled}
      href={href}
    >
      {isRippling ? (
        <span
          className="ripple"
          style={{
            left: coords.x,
            top: coords.y,
          }}
        />
      ) : (
        ""
      )}
      <span className="content">{children}</span>
    </Button>
  );
};

RippleButton.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.elementType.isRequired,
  type: PropTypes.bool,
  customStyles: PropTypes.string,
  testid: PropTypes.string,
  disabled: PropTypes.bool,
  href: PropTypes.string,
};

export default RippleButton;
